import http from './http'

export default {
  // 获取仪表盘统计数据
  getStatistics() {
    return http.get('/o1/dashboard_controller/statistics')
  },

  // 获取最近考试列表
  getRecentExams(params = {}) {
    return http.get('/o1/dashboard_controller/recentExams', params)
  },

  // 获取最近题库列表
  getRecentBanks(params = {}) {
    return http.get('/o1/dashboard_controller/recentBanks', params)
  },

  // 获取最近试卷列表
  getRecentPapers(params = {}) {
    return http.get('/o1/dashboard_controller/recentPapers', params)
  },

  // 获取考试趋势数据
  getExamTrend(params = {}) {
    return http.get('/o1/dashboard_controller/examTrend', params)
  },

  // 获取考试类型分布
  getExamTypeDistribution() {
    return http.get('/o1/dashboard_controller/examTypeDistribution')
  },

  // 获取系统状态
  getSystemStatus() {
    return http.get('/o1/dashboard_controller/systemStatus')
  }
}
